export const formål = [];

const input = document.getElementById('formål');
const datalist = document.getElementById('formålList');

const validCode = (pk, c) => formål.some(
  af => af.datakilde === pk && Number(af.kode) === Number(c)
);

export const invalidPlanIdList = ff => {
  const p = [];
  ff.filter(f =>
    ['Fremtidig', 'Nåværende', 'KpOmråde', 'RpOmråde'].indexOf(f.get('objtype')) < 0 &&
    !validCode(f.get('plankategori'), f.get('arealformål'))
  ).forEach(f => {
    const planid = f.get('planid');
    if (p.indexOf(planid) < 0) p.push(planid);
  });
  return p.join(', ');
};

export const retrieveCode = (i) => {
  const v = i.value;
  const dl = i.list;
  const selectedOption = dl.querySelector(`option[value="${v}"]`);
  return selectedOption ? selectedOption.dataset.code : null;
};

const fillInSelector = () => {
  const ua = navigator.userAgent;
  const epiphany = ua.includes('AppleWebKit') && ua.includes('Version');
  formål.forEach((f, i) => {
    if (i > 0 && f.kode > 999) { // skip header and old codes from 1985
      const o = document.createElement('option');
      // o.value = f.kode;
      o.value = f.tekst;
      const ik = `[${f.kode}] ${f.tekst}`;
      o.innerHTML = `${ik} | ${f.katNiva2}`;
      if (epiphany) o.value = ik; // otherwise it will not find codes
      // o.title = f.beskrivelse || f.hovedformål;
      o.dataset.code = f.kode; // only store code for feature update
      o.dataset.type = f.datakilde; // to be able to filter afterwards
      // // To be able to proceed when Nåværende is default choice:
      // if (i === 1) o.selected = true; // did not work
      datalist.appendChild(o);
      // if (i === 1) input.value = o.value; // did not work
    }
  });
};

export const filterDatalist = (type) => {
  // datalist.options only gives you enabled elements
  const l = datalist.children.length;
  for (let i = 0; i < l; i++) {
    const o = datalist.children.item(i);
    o.disabled = (o.dataset.type !== type);
  }
};

export const loadCodes = (jsonArray) => {
  jsonArray.forEach(o => formål.push(o));
  fillInSelector();
};

export const translate = (code, type) => {
  const l = formål.length;
  for (let i = 0; i < l; i++) {
    const row = formål[i];
    if (Number(row.kode) === Number(code) && row.datakilde === type)
      return `[${row.kode}] ${row.tekst}`;
  }
  return code;
};

export const getKat = (code, type) => {
  if (type === 'Fremtidig') return [
    'Arealbrukskategori',
    fremtidig.value.replace('Bebygd - ', '').replace('Skog - ', '')
  ];
  const l = formål.length;
  for (let i = 0; i < l; i++) {
    const row = formål[i];
    if (Number(row.kode) === Number(code) && row.datakilde === type)
      return [row.katNiva1, row.katNiva2];
  }
  return ['', ''];
};
